import { ComponentType } from "../../types/Questionnaire";

export const sequence = {
    sequence_empty_list: "Un nouveau questionnaire sera prochainement disponible. Nous t'informerons par SMS ou e-mail !",
};

export const sequenceIsDone = (components: ComponentType[]): boolean => {
    return components.every(component => {
        if (component.answered_questions_count / component.questions_count != 1)
            return false;
        
        return true;
    });
}